import React, { memo, useEffect } from "react";
import UserHeader from "../UserHeader";
import FormPageHeader from "../FormPageHeader";
import { useStyles } from "./style";
import { Box } from "@material-ui/core";
import LocationToggler from "../../LocationToggler";
import clsx from "clsx";
import {
  useLayoutToggle,
  useRedesignTabs,
} from "../../RedesignLayout/LayoutToggleContext";

const FormLayout = ({
  children,
  title,
  mode,
  pageName,
  parentLink,
  childLink,
  customTitle,
  hideHeader,
  showProfileTabs,
  paths,
  profileLocation,
  showLocationToggler,
  history,
  showLocationToggle,
  hidePageHeader,
  onLocationChange,
  isFeed,
  layoutType = "default",
  hideBreadcrumbs = false,
  headerRight = null,
  zenBackdrop = false,
  hideTopBar = false,
}) => {
  const classes = useStyles();
  const { useRedesign } = useLayoutToggle();
  const { setShowLocationSwitcher } = useRedesignTabs();
  const wantsLocationSwitcher = Boolean(
    showLocationToggle || showLocationToggler,
  );

  useEffect(() => {
    if (!useRedesign) return undefined;
    setShowLocationSwitcher(wantsLocationSwitcher);
    return () => setShowLocationSwitcher(false);
  }, [useRedesign, wantsLocationSwitcher, setShowLocationSwitcher]);

  const content = (
    <Box
      className={clsx({
        [classes.content]: layoutType === "default",
        [classes.contentLg]: layoutType === "lg",
        [classes.contentXl]: layoutType === "xl",
        [classes.contentFull]: layoutType === "full",
      })}
    >
      {showLocationToggler && !useRedesign && (
        <LocationToggler history={history} />
      )}
      {hideHeader !== true && (
        <FormPageHeader
          title={title}
          mode={mode}
          pageName={pageName}
          parentLink={parentLink}
          childLink={childLink}
          customTitle={customTitle}
          hideBreadcrumbs={hideBreadcrumbs}
          headerRight={headerRight}
        />
      )}
      {children}
    </Box>
  );
  return (
    <>
      {!hideTopBar && (
        <Box className={classes.header}>
          <UserHeader
            title={title}
            showProfileTabs={showProfileTabs}
            profileTabs={paths}
            profileLocation={profileLocation}
            showLocationToggle={showLocationToggle ?? false}
            hidePageHeader={hidePageHeader}
            showPageTitle={false}
            onLocationChange={(data) => {
              typeof onLocationChange === "function" && onLocationChange(data);
            }}
          />
        </Box>
      )}
      {zenBackdrop ? (
        <Box className={classes.zenBackdrop}>{content}</Box>
      ) : (
        content
      )}
    </>
  );
};

export default memo(FormLayout);
